import styled from 'styled-components'

export const MessageContent = styled.p`
  font-size: 14px;
  font-family: ${(props) => props.theme.fontFamily};
  text-align: left;
  margin-top: 0;
`
